import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import Highlight from '../../../assets/svg/quickbooks-mc/highlight.svg';
import Footer from '../../../components/Footer';
import Metadata from '../../../components/Metadata';
import { PartnershipsHeader } from '../../../components/Partnerships';
import CallToAction from '../../../components/Partnerships/QuickbooksMailchimp/CallToAction';
import Carousel from '../../../components/Partnerships/QuickbooksMailchimp/Carousel';
import CaseStudies from '../../../components/Partnerships/QuickbooksMailchimp/CaseStudies';
import { COLORS } from '../../../constants/colors';
import QuickbooksData from '../../../data/partnerships/quickbooks';

const Superscript = () => {
  const content = QuickbooksData();

  return (
    <div className="partnerships-base partnerships-quickbooks-mailchimp">
      <Metadata
        data={content.QUICKBOOKS.caseStudies[0].metadata}
        host="local"
      />
      <PartnershipsHeader
        colors={{
          backButton: COLORS.licorice,
          backButtonBackground: COLORS.transparent,
          hamburger: COLORS.licorice,
          hamburgerBackground: COLORS.transparent,
          main: COLORS.licorice,
        }}
      />
      <section className="partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__border--top partnerships-quickbooks-mailchimp__bg--blue partnerships-quickbooks-mailchimp__padding">
        <div className="partnerships-global-container">
          <div className="partnerships-global-small">
            <div className="partnerships-quickbooks-mailchimp__center partnerships-global-margin-bottom">
              <h1 className="partnerships-quickbooks-mailchimp__h1 partnerships-global-margin-bottom--tiny">
                {content.QUICKBOOKS.caseStudies[0].introduction.title}
              </h1>
              <div className="partnerships-quickbooks-mailchimp__standfirst">
                {content.QUICKBOOKS.caseStudies[0].introduction.standfirst}
              </div>
            </div>
            <div className="partnerships-quickbooks-mailchimp__video">
              <iframe
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                frameBorder="0"
                height="315"
                src="https://www.youtube.com/embed/cJogrAjAQw8"
                title={content.QUICKBOOKS.caseStudies[0].introduction.title}
                width="565"
              />
            </div>
            <div className="partnerships-quickbooks-mailchimp__video-caption">
              {content.QUICKBOOKS.caseStudies[0].introduction.caption}
            </div>
            <div className="partnerships-quickbooks-mailchimp__video-meta">
              <div className="partnerships-quickbooks-mailchimp__video-description">
                {
                  content.QUICKBOOKS.caseStudies[0].introduction
                    .videoDescription
                }
              </div>
              <div className="partnerships-quickbooks-mailchimp__video-credits">
                <div className="partnerships-global-margin-bottom--tiny">
                  <strong>CREW</strong>
                </div>
                {content.QUICKBOOKS.caseStudies[0].introduction.videoCredits}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__bg--beige partnerships-quickbooks-mailchimp__padding">
        <div className="partnerships-global-container">
          <div className="partnerships-global-small">
            <div className="partnerships-quickbooks-mailchimp__split">
              <div>
                <h3 className="partnerships-quickbooks-mailchimp__h3">
                  {content.QUICKBOOKS.caseStudies[0].section1.title}
                </h3>
              </div>
              <div className="partnerships-quickbooks-mailchimp__section-text">
                {content.QUICKBOOKS.caseStudies[0].section1.text}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__bg--pink partnerships-quickbooks-mailchimp__padding">
        <div className="partnerships-global-container">
          <div className="partnerships-global-small">
            <blockquote className="partnerships-quickbooks-mailchimp__quote partnerships-quickbooks-mailchimp__h2">
              {content.QUICKBOOKS.caseStudies[0].pullquote1.quote}
            </blockquote>
            <div className="partnerships-quickbooks-mailchimp__quote-image">
              <GatsbyImage
                alt="Papillon Living"
                className="partnerships-quickbooks-mailchimp__border-image"
                image={content.QUICKBOOKS.caseStudies[0].image2}
              />
            </div>
            <div className="partnerships-quickbooks-mailchimp__quote-attribution">
              {content.QUICKBOOKS.caseStudies[0].pullquote1.attribution}
            </div>
          </div>
        </div>
      </section>
      <section className="partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__bg--beige partnerships-quickbooks-mailchimp__padding">
        <div className="partnerships-global-container">
          <div className="partnerships-global-small">
            <div className="partnerships-quickbooks-mailchimp__split">
              <div className="partnerships-quickbooks-mailchimp__section-text">
                {content.QUICKBOOKS.caseStudies[0].section2.text}
              </div>
              <div>
                <GatsbyImage
                  alt="Papillon Living"
                  className="partnerships-quickbooks-mailchimp__border-image"
                  image={content.QUICKBOOKS.caseStudies[0].image3}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__bg--beige partnerships-quickbooks-mailchimp__padding">
        <div className="partnerships-global-container">
          <div className="partnerships-global-small">
            <div className="partnerships-quickbooks-mailchimp__split">
              <div>
                <h3 className="partnerships-quickbooks-mailchimp__h3">
                  {content.QUICKBOOKS.caseStudies[0].section3.title}
                </h3>
              </div>
              <div className="partnerships-quickbooks-mailchimp__section-text">
                {content.QUICKBOOKS.caseStudies[0].section3.text}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="partnerships-quickbooks-mailchimp__carousel partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__bg--gold partnerships-quickbooks-mailchimp__padding">
        <div className="partnerships-global-margin-bottom--small">
          <Carousel data={content.QUICKBOOKS.caseStudies[0].carousel} />
        </div>
        <div className="partnerships-global-container">
          <div className="partnerships-global-small">
            <div className="partnerships-quickbooks-mailchimp__carousel-caption">
              {content.QUICKBOOKS.caseStudies[0].sliderCaption}
            </div>
          </div>
        </div>
      </section>
      <section className="partnerships-quickbooks-mailchimp__border--bottom partnerships-quickbooks-mailchimp__bg--beige partnerships-quickbooks-mailchimp__padding">
        <div className="partnerships-global-container">
          <div className="partnerships-global-small">
            <div className="partnerships-quickbooks-mailchimp__split partnerships-global-margin-bottom--small">
              <div>
                <h3 className="partnerships-quickbooks-mailchimp__h3">
                  {content.QUICKBOOKS.caseStudies[0].section4.title}
                </h3>
              </div>
              <div className="partnerships-quickbooks-mailchimp__section-text">
                {content.QUICKBOOKS.caseStudies[0].section4.text}
              </div>
            </div>
            <div>
              <div className="partnerships-quickbooks-mailchimp__highlight">
                <Highlight />
              </div>
              <GatsbyImage
                alt="Papillon Living"
                className="partnerships-quickbooks-mailchimp__border-image"
                image={content.QUICKBOOKS.caseStudies[0].image4}
              />
            </div>
          </div>
        </div>
      </section>
      <CaseStudies
        data={[
          content.QUICKBOOKS.caseStudies[1],
          content.QUICKBOOKS.caseStudies[3],
        ]}
      />
      <CallToAction content={content.QUICKBOOKS.caseStudies[0].cta} />
      <Footer />
    </div>
  );
};

export default Superscript;
